import React from 'react';
import { FormContext } from 'react-hook-form';
import { KeyboardAvoidingView } from 'react-native';
import { Subheading } from 'react-native-paper';
import { Trans } from '@lingui/macro';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationScrollView from '@src/components/AuthenticationScrollView';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import OTPInput from '@src/components/OTPInput';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useInterval from '@src/hooks/useInterval';

import { Remaining } from './styled';
import { Props } from './types';
import useForm from './useForm';

const Screen: React.FC<Props> = ({ navigation, route }) => {
  const [ttl, setTtl] = React.useState(Math.floor(route.params.ttl));
  const { form, handleSubmit, loading } = useForm();

  useInterval(() => setTtl((lastTtl) => lastTtl - 1), 1000);

  React.useEffect(() => {
    if (ttl <= 0) {
      navigation.goBack();
    }
  }, [navigation, ttl]);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <AuthenticationScrollView>
          <KeyboardAvoidingView>
            <FormContext {...form}>
              <Subheading>
                <Trans>Code sent to {route.params.phone}</Trans>
              </Subheading>
              <OTPInput
                autoFocus
                disabled={loading}
                onSubmitEditing={handleSubmit}
                name="token"
              />
              <Remaining>
                <Trans>Send again in {ttl}s</Trans>
              </Remaining>
              <AuthenticationSendButton
                onPress={handleSubmit}
                loading={loading}
                disabled={loading}
              >
                <Trans>Confirm code</Trans>
              </AuthenticationSendButton>
            </FormContext>
          </KeyboardAvoidingView>
        </AuthenticationScrollView>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'ResetPasswordOTP';

export default Screen;
